import PropTypes from 'prop-types';
import React from 'react';
import NoSSR from 'react-no-ssr';
import moment from 'moment-timezone';
import { eventPropTypesShape } from '../../Includes/eventsProps';
import { buildImagePath } from '../../JobComponents/Company/Image/logo';
import { getMonthByNumber } from '../../Utilities/TimeFunctions';
import EventRegisterButtonContainer from '../EventRegisterButton/EventRegisterButtonContainer';

import './InPageEventDetailSection.scss';

const InPageEventDetailSection = (props) => {
    const { isUserRegistered, setUserAsRegistered, event } = props;
    const injectedTransforms = { default: '' };
    const imagePath = buildImagePath(
        '/v1561056921/calendar_image_milywa.svg',
        'default',
        injectedTransforms
    );

    const startDateUTC = new Date(moment.tz(event.startTime, 'UTC'));
    const momentStartTime = moment(startDateUTC).tz('America/New_York');
    const momentEndTime = moment(new Date(moment.tz(event.endTime, 'UTC'))).tz(
        'America/New_York'
    );
    const startTimeFormatted = momentStartTime.format('h:mma');
    const endTimeFormatted = momentEndTime.format('h:mma');
    const month = getMonthByNumber(momentStartTime.format('M'));
    const day = momentStartTime.format('D');
    const year = momentStartTime.format('YYYY');

    return (
        <div className="component-Events-InPageEventDetailSection">
            <img className="calendar-svg" src={imagePath} alt={event.title} />
            <div className="middle-section">
                <div className="full-date-text-display">{`${month} ${day}, ${year}`}</div>
                <NoSSR>
                    <div className="event-time-display">{`${startTimeFormatted} - ${endTimeFormatted} ET`}</div>
                </NoSSR>
            </div>
            <div className="inPageEventDetailSection-button">
                <EventRegisterButtonContainer
                    event={event}
                    isUserRegistered={isUserRegistered}
                    setUserAsRegistered={setUserAsRegistered}
                    isSingleEventPage
                />
            </div>
        </div>
    );
};

InPageEventDetailSection.propTypes = {
    /**
     * single event data
     */
    event: eventPropTypesShape.isRequired,
    /**
     * whether user is register for the event or not
     */
    isUserRegistered: PropTypes.bool.isRequired,
    /**
     * set userRegistered to true
     */
    setUserAsRegistered: PropTypes.func.isRequired,
};

InPageEventDetailSection.displayName = 'InPageEventDetailSection';

export default InPageEventDetailSection;
